"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Filter_1 = __importDefault(require("./Filter"));
const react_1 = require("react");
// Registreringsmerke, Kategori, Type, Eier, Operator, Registreringsdato
let filterSelection = [
    "mark",
    "aircraftModelCategory",
    "mainOwner",
    "aircraftName",
    "operator",
    "registrationDate",
    //  "airworthinessCategory",
    //  "aircraftConstructionYear",
    //  "mtom",
    //  "operator",
];
const FilterGroup = (props) => {
    const [filterState, setFilterState] = (0, react_1.useState)(undefined);
    const [showAllFilters, toggleAllFilters] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!filterState) {
            const filterData = {};
            props.filters.forEach((filter) => {
                var _a;
                let key = filter.name;
                filterData[key] = {
                    name: filter.name,
                    data: (_a = filter.data) !== null && _a !== void 0 ? _a : [],
                    type: filter.type,
                    label: props.labels[key],
                    value: undefined,
                    expanded: false,
                    active: false,
                };
            });
            setFilterState(filterData);
        }
    });
    const changeFilter = (operation, data) => {
        if (!filterState) {
            return;
        }
        Object.keys(filterState).forEach((key) => {
            if (filterState[key].name === data.name) {
                filterState[key].value = data.value;
            }
        });
        if (operation === "expand") {
            Object.keys(filterState).forEach((key) => {
                if (filterState[key].name !== data.name)
                    filterState[key].expanded = false;
                else
                    filterState[key].expanded = data.expanded;
            });
        }
        props.submit(filterState);
    };
    let filterKeys = filterState ? Object.keys(filterState) : [];
    if (!showAllFilters)
        filterKeys = filterSelection;
    else {
        // reorder keys so it starts with values of filterSelection
        let keysEdit = [];
        filterSelection.forEach((s) => keysEdit.push(s));
        filterKeys.forEach((s) => {
            if (keysEdit.indexOf(s) < 0)
                keysEdit.push(s);
        });
        filterKeys = keysEdit;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "m-filter-group", children: [filterState &&
                filterKeys.map((key, i) => {
                    return ((showAllFilters || i < 6) && ((0, jsx_runtime_1.jsx)(Filter_1.default, { data: filterState[key], changeFilter: changeFilter }, i)));
                }), (0, jsx_runtime_1.jsx)("div", { className: "m-filter-container toggle-filters", children: (0, jsx_runtime_1.jsxs)("button", { onClick: () => {
                        toggleAllFilters(!showAllFilters);
                    }, children: [(0, jsx_runtime_1.jsx)("img", { src: "/Resources/icons/icon_filter.svg", width: "22", alt: "", "aria-hidden": "true" }), showAllFilters ? "Skjul filter" : "Alle filtre"] }) })] }));
};
exports.default = FilterGroup;
